// https://vuex.vuejs.org/en/actions.html
import Vue from 'vue';
import { RepositoryFactory } from '../repositories/repositoryFactory';
import apiService from '../repositories/apiService';

export default {
    getRole({ commit }) {
        // We need to return a promise in order to pass the error up to the Vue component.
        return new Promise((resolve, reject) => {
            RepositoryFactory.get('roles')
                .getRole()
                .then((response) => {
                    commit('setRole', response.data.role);
                    commit('setIsParish', response.data.isParish);
                    commit('setHasDelegations', response.data.hasDelegations);
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    getUserLocations(state, payload) {
        return new Promise((resolve, reject) => {
            RepositoryFactory.get('people')
                .getUserLocations()
                .then((response) => {
                    state.commit('setUserLocations', response.data.locations);
                    state.commit('setError', '');
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                    state.commit('setError', error);
                });
        });
    }

    // destroyToken(context) {
    //     axios.defaults.headers.common.Authorization = context.state.token;
    //     return new Promise((resolve, reject) => {
    //         if (context.getters.loggedIn) {
    //             axios.post('/auth/logout')
    //                 .then((response) => {
    //                     localStorage.removeItem('access_token');
    //                     context.commit('destroyToken');
    //                     resolve(response);
    //                     // console.log(response);
    //                     // context.commit('addTodo', response.data)
    //                 })
    //                 .catch((error) => {
    //                     // this handles the case of if someone wants to enter their own localstorage token
    //                     localStorage.removeItem('access_token');
    //                     context.commit('destroyToken');
    //                     reject(error); // TO DO look up what this does. Maybe delete this
    //                 });
    //         }
    //     });
    // },
    // setToken(context, newtoken) {
    //     return new Promise((resolve, reject) => {
    //         localStorage.setItem('access_token', newtoken);
    //         context.commit('retrieveToken', newtoken);
    //         resolve();
    //         // console.log(response);
    //         // context.commit('addTodo', response.data)
    //     });
    // },
    // updateSelects(context, selects) {
    // // if the area is put in, then make sure the regions are filtered.
    // // and then the campuses are filtered from the region
    //     // console.log(selects);
    //     if (selects.area != null) {
    //         // console.log(context.getters.regionsFiltered(selects.area));
    //         context.commit('SET_REGIONS', context.getters.regionsFiltered(selects.area));
    //     }
    // },
    // retrieveToken(context, credentials) {
    //     return new Promise((resolve, reject) => {
    //         axios.post('/auth/login', {
    //             email: credentials.email,
    //             password: credentials.password,
    //         })
    //             .then((response) => {
    //                 const token = `Bearer ${response.data.access_token}`;

    //                 // Local storage tokens are susceptible to Cross Site Scripting attacks
    //                 // Cookies are vulnerable to CSRF attacks
    //                 localStorage.setItem('access_token', token);
    //                 context.commit('retrieveToken', token);
    //                 resolve(response);

    //                 const decoded = jwtDecode(token);
    //                 localStorage.setItem('role', decoded.role);
    //                 context.commit('retrieveRole', decoded.role);
    //             })
    //             .catch((error) => {
    //                 // eslint-disable-next-line no-console

    //                 reject(error);
    //             });
    //     });
    // },
    // authorized(context, role) {
    //     // if the user's role is in this roles thing, return true
    //     return new Promise((resolve, reject) => {
    //         resolve(true);
    //     });
    // },
};
